/* eslint-disable no-invalid-this */
// CONSTANTS are all caps.
const NS = 'BioListBlock';
const CLS = 'bioListBlock';
const WG = '.' + CLS + '-';
const BLI = '.bioListItem-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/bioListBlock.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

export class BioListBlock {
	constructor($el) {
		// $el is the widget node return by the loadBioListBlock function
		this.$el = $el;
	}

	init() {
		this.setBioListBlock();
	}

	setBioListBlock() {
		// on load, get the url's hash
		// if there is a hash value, check if we have a matching list item
		// trigger a click on it
	}

	// Add more functions like on above here
}
